import Neighborhood from './Neighborhood';
import Province     from './Province'    ;
import City         from './City'        ;
import Area         from './Area'        ;

type Props = {
  Neighborhood: typeof Neighborhood;
  Province    : typeof Province    ;
  City        : typeof City        ;
  Area        : typeof Area        ;
}

const LocationDropdowns: Props = {
  Neighborhood,
  Province    ,
  City        ,
  Area        ,
}

export default LocationDropdowns;
